module.exports = __webpack_public_path__ + "static/media/generali-logo2.ce0638d1.png";